// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Da9Q","errors":"Errors_errors__27MsX"};